import pipe from 'ramda/es/pipe';
import { create, State, StateCreator, StoreMutatorIdentifier } from 'zustand';
import { devtools, subscribeWithSelector } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';

import { logger } from '../middleware/logger';

const o = {
  store: `${__UNIQUENAME__}-store`,
  enabled: __DEV__,
};

export const createStore = <
  T extends State,
  Mps extends [StoreMutatorIdentifier, unknown][] = [],
>(
  f: StateCreator<T, [['zustand/immer', never]], Mps>
) => {
  return pipe(
    _ => logger<T>(_, o),
    _ => devtools(_, o),
    _ => immer(_ as StateCreator<T, [['zustand/immer', never]], [['zustand/devtools', never]]>),
    _ => subscribeWithSelector(_),
    _ => create(_)
  )(f);
};
